export default {
  props: {
    inputId: {
      type: Boolean,
      default: false
    },

    outputId: {
      type: Boolean,
      default: false
    },

    multiple: {
      type: Boolean,
      default: false
    },

    sortable: {
      type: Boolean,
      default: false
    },

    value: {
      // type: [Object, Array],
      default: undefined
    },

    dropdown: {
      type: Boolean,
      default: true
    },

    parameters: {
      type: Object,
      default: undefined
    },

    sort: {
      type: Object,
      default: undefined
    },

    filter: {
      type: Function,
      default: undefined,
    }
  },
};
